<div class="container">
    <div class="container d-flex flex-row gap-5">
        <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" 
                id="flexRadioDefault1" [value]="$parametricList.typeTypeVehicle[0]?.idParametroDetalle"
                [(ngModel)]="tipoVehiculo">
            <label class="form-check-label" for="flexRadioDefault1">
                Vehículos internos
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" 
                id="flexRadioDefault2" [value]="$parametricList.typeTypeVehicle[1]?.idParametroDetalle"
                [(ngModel)]="tipoVehiculo">
            <label class="form-check-label" for="flexRadioDefault2">
                Vehículos subcontratados
            </label>
          </div>
    </div>

    <br>
    <br>

    <div *ngIf="tipoVehiculo === $parametricList.typeTypeVehicle[0]?.idParametroDetalle">
        <app-gestion-vehiculos-internos
          [guardar]="guardar"
          [solicitudID]="solicitudID"
          [reloadTable]="reloadTableVehicles"
          (habilitGuardar)="habilitarGuardar = $event"
          (dataVehiculoInterno)="onSaveVehicle($event)"
          (liberarVehiculoInterno)="liberarVehiculoInterno($event)">
        </app-gestion-vehiculos-internos>
    </div>

    <div *ngIf="tipoVehiculo === $parametricList.typeTypeVehicle[1]?.idParametroDetalle">
        <app-gestion-vehiculos-subcontratados
            [submitted]="guardar"
            (dataVehicleSub)="onSaveVehicleSub($event)">
        </app-gestion-vehiculos-subcontratados>
    </div>

    <br>
    <br>

    <div class="d-flex flex-row-reverse">
        <div class="col-md-3 row gap-2">
          <button type="button" (click)="saveVehicleSub()" class="btn btn-secondary col-md-5" [disabled]="!habilitarGuardar && tipoVehiculo !== $parametricList.typeTypeVehicle[1]?.idParametroDetalle">
            GUARDAR
          </button>

          <button type="button" (click)="onCancel()" class="btn btn-secondary col-md-5">
            CANCELAR
          </button>
        </div>
      </div>
</div>